export default {
  methods: {
    closeToolbar(editor) {
      const emojiBtn = editor.contentDocument.querySelector('.tox-tbtn.tox-tbtn--enabled[title="Emoticons"]');

      if (emojiBtn) {
        emojiBtn.click();
      }
    },
  },
};
